import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { Review } from '../../types';

interface ReviewCardProps {
  review: Review;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-2xl border border-neutral-200/50 p-6 floating-card hover:floating-card-hover transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h5 className="font-semibold text-primary-900">{review.userName}</h5>
          <p className="text-sm text-neutral-500">{formatDate(review.createdAt)}</p>
        </div>
        <div className="flex items-center">
          {[1, 2, 3, 4, 5].map((star) => (
            <StarIcon
              key={star}
              className={`h-4 w-4 ${
                star <= review.rating ? 'text-yellow-400' : 'text-neutral-300'
              }`}
            />
          ))}
          <span className="ml-2 text-sm font-medium text-neutral-700">
            {review.rating}/5
          </span>
        </div>
      </div>

      <h6 className="font-medium text-primary-800 mb-2">{review.title}</h6>
      <p className="text-neutral-700 mb-4">{review.comment}</p>

      {review.images && review.images.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4">
          {review.images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Review ${index + 1}`}
              className="w-full h-20 object-cover rounded-md"
            />
          ))}
        </div>
      )}

      <div className="flex items-center justify-between text-sm text-neutral-500">
        <span>Was this review helpful?</span>
        <div className="flex items-center space-x-2">
          <button className="hover:text-primary-600 transition-colors duration-200">
            👍 {review.helpful}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
